import meliLogo from '../../../../../assets/img/logos/meliLogo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faXmarkCircle
} from '@fortawesome/free-solid-svg-icons';
import { Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getUserMlByUserId } from 'redux/mlSlice';
import { useEffect, useState } from 'react';

const WidgetMeli = () => {
  // * States
  const { user } = useSelector(state => state.ml);
  const { data } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // * Methods
  const FetchData = async () => {
    setLoading(true);
    await dispatch(getUserMlByUserId(data.userId));
    setLoading(false);
  };

  // * Life Cycle
  useEffect(() => {
    FetchData();
  }, []);

  return (
    <>
      <Card className="bg-white h-100">
        <Card.Body className="d-flex align-items-center">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="d-flex align-items-center" style={{ gap: 25 }}>
              <FontAwesomeIcon
                icon={user ? faCircleCheck : faXmarkCircle}
                color={user ? '#2c7be5' : 'red'}
                className="position-absolute top-0 end-0 mt-3 me-3"
              />
              <div style={{ maxWidth: 60 }}>
                <img
                  src={meliLogo}
                  alt="Logo de Mercado Libre"
                  style={{
                    objectFit: 'contain'
                  }}
                  className="w-100 h-100"
                />
              </div>
              {user ? (
                <div className="w-100 d-flex flex-column">
                  <div className="w-100 d-flex justify-content-between">
                    <h5 className="text-black">Conectado a Mercadolibre</h5>
                  </div>
                  <p className="mb-2" style={{ color: '#2c7be5' }}>
                    {`Nombre de la cuenta: ${user.ml_user}`}
                  </p>
                  <p className="m-0">
                    {`ID de la cuenta: ${user.ml_id}`}
                    <a
                      href={`${user.permalink}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="ms-2">Ver perfil</span>
                    </a>
                  </p>
                </div>
              ) : (
                <div className="w-100 d-flex flex-column">
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <h5 className="text-black mb-0">
                      No conectado con Mercadolibre
                    </h5>
                  </div>
                </div>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default WidgetMeli;
